import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=5f4e2dad&scoped=true&lang=pug&"
import script from "./TrueFalse.vue?vue&type=script&lang=ts&"
export * from "./TrueFalse.vue?vue&type=script&lang=ts&"
import style0 from "./TrueFalse.vue?vue&type=style&index=0&id=5f4e2dad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e2dad",
  null
  
)

export default component.exports